import { themes } from '../FollowGreenTheme/initThemes';
import layoutSettings from './Layout/LayoutSettings';

// UPDATE BELOW CODE
// DOC http://demos.ui-lib.com/matx-react-doc/layout.html
export const FollowGreenLayoutSettings = {
  activeLayout: 'layout', // layout, layout2
  activeTheme: 'blue', // View all valid theme colors inside FollowGreenTheme/themeColors.js
  perfectScrollbar: true,

  themes: themes,
  layoutSettings, // open Layout/LayoutSettings.js

  secondarysidebar: {
    show: false,
    open: false,
    theme: 'slateDark1', // View all valid theme colors inside FollowGreenTheme/themeColors.js
  },
  // Footer options
  footer: {
    show: true,
    fixed: false,
    theme: 'follow', // View all valid theme colors inside FollowGreenTheme/themeColors.js
  },
};
